import {
    CONFIRMED_GET_MEDICINE_TYPES,
    CONFIRMED_CREATE_MEDICINE_TYPE,
    CONFIRMED_DELETE_MEDICINE_TYPE,
    CONFIRMED_EDIT_MEDICINE_TYPE,
  } from "../types/MedicineTypeTypes";
  
  import {
    getMedicineTypes,
    createMedicineType,
    updateMedicineType,
    deleteMedicineType,
    formatMedicineTypes,
  } from "../../services/MedicineTypeService";
  
  import {
    handleError,
    handleSuccess,
    showErrorAlert,
  } from "../../services/ErrorHandlingService";
  
  // Get list
  export function getMedicineTypeAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getMedicineTypes(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.status === "success") {
          const list = formatMedicineTypes(response.data.data);
          const num_rows = response.data.num_rows || 0;
  
          dispatch({
            type: CONFIRMED_GET_MEDICINE_TYPES,
            payload: { list, num_rows },
          });
        } else {
          handleError("Failed to get Medicine Types");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to get Medicine Types");
      }
    };
  }
  
  // Delete
  export function deleteMedicineTypeAction(medicineTypeId) {
    return async (dispatch) => {
      try {
        await deleteMedicineType(medicineTypeId);
  
        dispatch({
          type: CONFIRMED_DELETE_MEDICINE_TYPE,
          payload: { medicine_type_id: medicineTypeId },
        });
  
        handleSuccess("Medicine Type deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete Medicine Type");
      }
    };
  }
  
  // Create
  export function createMedicineTypeAction(data, navigate) {
    return async (dispatch) => {
      try {
        const response = await createMedicineType(data);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatMedicineTypes([response.data.data])[0];
  
          dispatch({
            type: CONFIRMED_CREATE_MEDICINE_TYPE,
            payload: formatted,
          });
  
          if (navigate) navigate("/medicine-types");
  
          handleSuccess("Medicine Type created successfully!");
        } else {
          showErrorAlert("Failed to create Medicine Type");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to create Medicine Type");
      }
    };
  }
  
  // Update
  export function updateMedicineTypeAction(data, medicineTypeId, navigate) {
    return async (dispatch) => {
      try {
        const payload = {
          ...data,
          medicine_type_id: medicineTypeId,
        };
  
        const response = await updateMedicineType(payload);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatMedicineTypes([response.data.data])[0];
  
          dispatch({
            type: CONFIRMED_EDIT_MEDICINE_TYPE,
            payload: formatted,
          });
  
          if (navigate) navigate("/medicine-types");
  
          handleSuccess("Medicine Type updated successfully!");
        } else {
          showErrorAlert("Failed to update Medicine Type");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to update Medicine Type");
      }
    };
  }
  